// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about__container {
  display: grid;
  grid-template-columns: 35% 53%;
  gap: 12%;
}

.about__portrait {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 40rem;
  border: 1rem solid var(--color-white);
  transition: var(--transition);
  overflow: hidden;
  width: 100%;
}
.about__portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.about__portrait:hover {
  border-width: 0;
}

.about__cards {
  margin: 3rem 0 1.5rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.card.about__card {
  text-align: center;
}

.about__card-icon {
  font-size: 1.3rem;
  color: var(--color-black);
  border-radius: var(--border-radius-3);
  width: -moz-fit-content;
  width: fit-content;
  margin-inline: auto;
  padding: 0.6rem;
  display: flex;
  align-items: center;
  transition: var(--transition);
}

.card.about__card:hover .about__card-icon {
  background: var(--color-primary);
  color: var(--color-white);
}

.card.about__card h5 {
  margin: 1rem 0;
}

.about__right p {
  margin-bottom: 0.8rem;
}

.about__right .btn {
  margin-top: 2.5rem;
}

/* Media queries tablets */

@media screen and (max-width: 1024px) {
  .about__left {
    display: none;
  }

  .about__container {
    grid-template-columns: 1fr;
  }

  .about__right h2 {
    text-align: center;
  }
}

/* Media queries phones */

@media screen and (max-width: 600px) {
  .about__cards {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .about__right .btn {
    margin-top: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/about/about.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;;AAEzB;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".about__container {\n  display: grid;\n  grid-template-columns: 35% 53%;\n  gap: 12%;\n}\n\n.about__portrait {\n  height: fit-content;\n  max-height: 40rem;\n  border: 1rem solid var(--color-white);\n  transition: var(--transition);\n  overflow: hidden;\n  width: 100%;\n}\n.about__portrait img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.about__portrait:hover {\n  border-width: 0;\n}\n\n.about__cards {\n  margin: 3rem 0 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n}\n\n.card.about__card {\n  text-align: center;\n}\n\n.about__card-icon {\n  font-size: 1.3rem;\n  color: var(--color-black);\n  border-radius: var(--border-radius-3);\n  width: fit-content;\n  margin-inline: auto;\n  padding: 0.6rem;\n  display: flex;\n  align-items: center;\n  transition: var(--transition);\n}\n\n.card.about__card:hover .about__card-icon {\n  background: var(--color-primary);\n  color: var(--color-white);\n}\n\n.card.about__card h5 {\n  margin: 1rem 0;\n}\n\n.about__right p {\n  margin-bottom: 0.8rem;\n}\n\n.about__right .btn {\n  margin-top: 2.5rem;\n}\n\n/* Media queries tablets */\n\n@media screen and (max-width: 1024px) {\n  .about__left {\n    display: none;\n  }\n\n  .about__container {\n    grid-template-columns: 1fr;\n  }\n\n  .about__right h2 {\n    text-align: center;\n  }\n}\n\n/* Media queries phones */\n\n@media screen and (max-width: 600px) {\n  .about__cards {\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n\n  .about__right .btn {\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
